import { Appearance, Mode } from "../types";

export const getAppearanceModeColor = (appearance: Appearance, mode: Mode) => {
  switch (mode) {
    case 'primary':
      return appearance !== 'fill' ? "var(--colorBlue)" : "var(--colorWhite)"
    case 'success':
      return appearance !== 'fill' ? "var(--colorGreen)" : "var(--colorWhite)"
    case 'danger':
      return appearance !== 'fill' ? "var(--colorRed)" : "var(--colorWhite)"
    case 'warn':
      return appearance !== 'fill' ? "var(--colorOrange)" : "var(--colorWhite)"
    case 'secondary':
    default:
      return appearance !== 'fill' ? "var(--colorText)" : "var(--colorText)"
  }
}
